import { useEffect } from 'react';
import { message } from 'ui';
import { useUserQuery } from '../../../../queries';
import { type QuickViewCardUser, QuickViewUserCard } from '../../../quick-view-user-card';

export type UserPopoverWithQuery = {
  fallback?: Omit<QuickViewCardUser, 'id'>;
  userId: string;
};

const UserPopoverContentWithQuery = ({ fallback, userId }: UserPopoverWithQuery) => {
  const {
    data: fetchedUser,
    isError,
    isLoading,
  } = useUserQuery({
    filter: { userId },
    options: { throwOnError: false },
  });

  useEffect(() => {
    if (isError && !fallback) {
      message.error('Unable to load user details.');
    }
  }, [fallback, isError]);

  const fallbackUser = fallback ? { ...fallback, id: userId } : undefined;
  const user = isError ? fallbackUser : fetchedUser;

  return <QuickViewUserCard {...(isLoading || !user ? { isLoading: true } : { isLoading: false, user })} />;
};

export default UserPopoverContentWithQuery;
